export default "__VITE_ASSET__D48j1VhH__"